import { attributes, define, Events } from "@type-r/models";
import { useEvent } from "@type-r/react";
import { Flex, Page } from "lqx-react";
import * as React from "react";
import { InvoiceLandingSummary } from "../api/invoices";
import { SelectFilter } from "../common";
import { ReviewDetails, ReviewTiles } from "./review";
import { TodoDetails, TodoTiles } from "./todo";

@define
export class InvoicesLandingState extends attributes({
    filter: 'todo',
    category: 'not-sent',
    invoices: InvoiceLandingSummary,
}) {
    async fetch() {
        await this.invoices.fetch();
        return this;
    }

    get isReady() {
        return this.invoices.isTodoReady;
    }

    get getCount() {
        return this.invoices.getCount;
    }
}

export const InvoicesLandingPage = ({ $state: $state }: { $state: InvoicesLandingState }) => {

    useEvent(Events, "Landing:notSentChanged", async () => $state.invoices.fetch());

    return (
        <Page
            menuWidth={450}
            maxWidth="xl"

            left={
                <>
                    <SelectFilter $filter={$state.$.filter} model={$state.invoices} />
                    {
                        $state.filter === "todo" ?
                            <TodoTiles $category={$state.$.category} model={$state.invoices} /> :
                            $state.filter === "review" ?
                                <ReviewTiles $category={$state.$.category} $model={$state.invoices} /> :
                                <h1>TBD</h1>
                    }
                </>
            }
        >
            {
                $state.filter === 'todo' ?
                    <TodoDetails category={$state.category} state={$state.invoices} />
                    :
                    $state.filter === 'review' ?
                        <ReviewDetails category={$state.category} state={$state.invoices}/>
                        :
                        <Flex center>
                            <h1>TBD</h1>
                        </Flex>
            }

        </Page>
    )
}